import axios, { AxiosInstance } from "axios";
import {
  clearAllCookies,
  clearBrowserStorage,
  broadcastLogout,
} from "@/utils/cookieUtils";

const createAxiosInstance = (baseURL: string): AxiosInstance => {
  const instance = axios.create({
    baseURL,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
    },
  });

  instance.interceptors.request.use(
    (config: any) => {
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      // 401 Unauthorized 에러 처리 - 세션 만료
      if (error.response?.status === 401) {
        if (!window.location.pathname.includes("/login")) {
          // 초기화
          clearAllCookies();
          clearBrowserStorage();
          broadcastLogout();
          window.location.href = "/login";
        }
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export default createAxiosInstance;
